import React from 'react';
import Reveal from '../../../components/ui/Reveal';
import Icon from '../../../components/AppIcon';

const MapSection = () => {
  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-[#0D1C3D]">แผนที่ตั้ง</h2>
          <p className="text-muted-foreground text-base lg:text-lg mt-2">ที่ตั้งและการเดินทางมายังที่ว่าการอำเภอเทิง</p>
        </div>
        <Reveal y={18} duration={720}>
          <div className="rounded-xl overflow-hidden shadow-government border border-border">
            <iframe
              title="map-thoughng"
              src="https://www.google.com/maps?q=Thoeng%20District%20Office&output=embed"
              className="w-full h-[380px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="flex justify-center mt-4 text-muted-foreground text-sm">
            <Icon name="MapPin" size={16} className="mr-2" />
            <span>พิกัดโดยประมาณจาก Google Maps</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default MapSection;


